import { discrepancies } from "./discrepancies";
import { reconciliation_status } from "./reconciliation_status";

// The report= seam: every future family registers here.
export const reports = { discrepancies, reconciliation_status };
export const reportList = Object.values(reports);
